<template>
    <div class="flex min-h-[100vh] flex-col">
        <SiteNotificationContainer />

        <TopBar />

        <Header />

        <main class="flex-1">
            <slot />
        </main>

        <Footer />
    </div>
</template>
<script setup lang="ts">
import Footer from '~/layouts/includes/Footer.vue';
import Header from '~/layouts/includes/Header.vue';
import SiteNotificationContainer from '~/layouts/includes/SiteNotificationContainer.vue';

useServerHead({
    link: [
        {
            href: '/images/favicon.svg',
            rel: 'icon',
            type: 'image/svg+xml',
        },
    ],
});
</script>
